export default __webpack_public_path__ + "static/media/ofek1.196d8acb.jpg";